module.exports = "/img/videos/2.c1daee.mp4";